import { AddPeriscopeToInitiativeNotification } from './AddPeriscopeToInitiativeNotification';
import { AddPeriscopeToInitiativeTaskNotification } from './AddPeriscopeToInitiativeTaskNotification';
import React from 'react';
import { RemovePeriscopeFromInitiativeNotification } from './RemovePeriscopeFromInitiativeNotification';
export const PeriscopeInitiativeNotifications = () => React.createElement(React.Fragment, null,
    React.createElement(AddPeriscopeToInitiativeNotification, null),
    React.createElement(AddPeriscopeToInitiativeTaskNotification, null),
    React.createElement(RemovePeriscopeFromInitiativeNotification, null));
